import { useEffect, useRef } from "react";

interface CaptureCountdownProps {
  secondsLeft: number | null;
  onCancel: () => void;
  className?: string;
}

export function CaptureCountdown({ secondsLeft, onCancel, className }: CaptureCountdownProps) {
  const flashRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (secondsLeft === 0 && flashRef.current) {
      flashRef.current.classList.add("animate-flash");
      const t = setTimeout(() => flashRef.current?.classList.remove("animate-flash"), 400);
      return () => clearTimeout(t);
    }
  }, [secondsLeft]);

  if (secondsLeft === null) return null;

  return (
    <div
      className={className}
      role="dialog"
      aria-label="Capture countdown"
    >
      <div
        ref={flashRef}
        className="pointer-events-none absolute inset-0 bg-white opacity-0"
        aria-hidden
      />
      <div className="flex flex-col items-center justify-center gap-4 rounded-lg bg-background/95 p-8 shadow-xl">
        <p className="text-sm text-muted-foreground">
          {secondsLeft > 0
            ? "Prepare your screen (menus, tooltips). Capturing in…"
            : "Capturing…"}
        </p>
        {secondsLeft > 0 && (
          <span className="text-6xl font-bold tabular-nums text-primary">
            {secondsLeft}
          </span>
        )}
        <button
          type="button"
          onClick={onCancel}
          className="text-sm text-muted-foreground underline hover:text-foreground"
        >
          Cancel
        </button>
      </div>
    </div>
  );
}
